import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=848d89ca&"
import script from "./inspect.vue?vue&type=script&lang=js&"
export * from "./inspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports